import axios from "axios";

/**
 * 品牌列表
 * wiki: http://172.32.255.2:8090/pages/viewpage.action?pageId=8130218
 */
export async function getBrandList(data: any) {
  return axios({
    method: "post",
    url: "/carOwner/ownerService/ownerCar/v1/brandList",
    data
  });
}
/**
 * 车系列表
 * wiki: http://172.32.255.2:8090/pages/viewpage.action?pageId=8130224
 */
export async function modelListFn(data: any) {
  return axios({
    method: "post",
    url: "/carOwner/ownerService/ownerCar/v1/modelList",
    data
  });
}

/**
 * H5发送短信验证码
 * wiki: http://172.32.255.2:8090/pages/viewpage.action?pageId=8135078
 */
export async function sendSmsCode(data: string) {
  return axios({
    method: "get",
    url: "/user-proxy/user/ownerInfo/h5/sendSmsCode?" + data,
    prefix: "carmanagerapp"
  });
}

/**
 * H5成为车主
 * wiki: http://172.32.255.2:8090/pages/viewpage.action?pageId=8135080
 */
export async function becomeOwner(data: object) {
  return axios({
    method: "post",
    url: "/user-proxy/user/ownerInfo/h5/becomeOwner",
    data,
    prefix: "carmanagerapp"
  });
}

/**
 * 洗车服务 H5发送短信验证码
 * wiki: http://172.32.255.2:8090/pages/viewpage.action?pageId=8135131
 */
export async function sendSmsCodeWashCar(data: any) {
  return axios({
    method: "get",
    url: "/carOwner/ownerService/index/sendSmsCode?" + data
  });
}

/**
 * 洗车服务验证H5短信验证码
 * wiki: http://172.32.255.2:8090/pages/viewpage.action?pageId=8135133
 */
export async function checkSmsCode(data: any) {
  return axios({
    method: "post",
    url: "/carOwner/ownerService/index/checkSmsCode",
    data
  });
}

/**
 * H5立即领取
 * wiki: http://172.32.255.2:8090/pages/viewpage.action?pageId=8135083
 */
export async function saveApply(data: any) {
  return axios({
    method: "post",
    url: "/user-proxy/user/ownerInfo/h5/saveApply",
    data,
    prefix: "carmanagerapp"
  });
}

/**
 * H5转化数据回传
 * pf: "TOUTIAO", //enum 必填   platform   不需要自定义：TOUTIAO：头条  GDT：广点通      需要自定义：KUAISHOU：快手 IPINYOU：深演，品友 WEIBO：微博 IQIYI：爱奇艺 FEEDFLOW：阿里妈妈-超级推荐 BAIDU：百度 QUTOUTIAO：趣头条
 * et: "register", //enum 必填   转化类型   register：仅需传第一次注册   form：完成标签填写并提交
 * ett: new Date().getTime(), //long 必填  转化发生时间（时间戳格式，到毫秒），示例：1595939874000
 * py: 1, //double  转化金额（单位元，保留两位小数），需要计算ROI时必填
 * ld: ldUrl, //string 必填  h5落地页url，携带媒体参数的完整落地页url ，须进行url encode
 * ua: "Mozilla/5.0 (iPhone; CPU iPhone OS 13_2_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.3 Mobile/15E148 Safari/604.1", //string 用户访问h5时的user agent，须url encode
 * os: 1, //int 用户访问h5时的操作系统，MMA规范：  0:Android  1:IOS  2:WP  3:others
 * ip: "172.27.134.237", //string  用户访问h5时的客户端ip，可用于地域分析
 * ex: 1 //根据客户业务自定义，比如渠道参数、业务策略参数等
 * pm: 深演需要解析参数  eg: ldUrl = "http://app520.51gofunev.com/dist/#/bargainActivity?jack=1&tom=2"; pm = "clkid,jack;crtid,tom;";
 * 映射放到请求的pm参数中，要求进行url encode。
 * 格式：深演参数1,landing url对应的自定义参数名1;深演参数2,landing url对应的自定义参数名2;...
 * accid       否    推广账户id，如果媒体支持，建议回传
 * ordid       否    订单id，如果媒体支持，建议回传
 * planid       否    计划id，如果媒体支持，建议回传
 * crtid       必填    创意id
 * kwid           否    关键词id
 * kw           否    关键词
 * clkid       必填    点击id
 */
export async function h5TransferDataBack(params: any) {
  const { pf, et, ett, py, ld, pm, ua, os, ip, ex } = params;
  const _params: any = {
    pf: pf,
    et: et,
    ett: ett,
    ld: ld
  };
  if (pm) {
    _params["pm"] = pm;
  }
  if (ua) {
    _params["ua"] = ua;
  }
  if (py) {
    _params["py"] = py;
  }
  if (os) {
    _params["os"] = os;
  }
  if (ip) {
    _params["ip"] = ip;
  }
  if (ex) {
    _params["ex"] = ex;
  }
  return axios({
    method: "get",
    url: "/cvt/1032sjbd7",
    params:_params,
    prefix: "tdiDataBack",
  });
}
